import React from 'react'
import {useHistory} from 'react-router-dom'
import {motion} from "framer-motion";

const contVariant={
  hidden:{
    opacity:0
  },
  visible:{
    opacity:1,
    transition:{
      duration:0.5
    }
  }
}
export default function Template0() {
	const history=useHistory()
	const data=JSON.parse(localStorage.getItem("resumeData"))
	function download(){
		var body=document.body.innerHTML
		var data=document.getElementById("resume").innerHTML
		document.body.innerHTML=data
		document.body.style.background="white"
		window.print()
		document.body.style.background="linear-gradient(to right,rgb(10, 81, 89) 20%,rgb(13, 153, 136),rgb(10, 81, 89) 80%)"
		document.body.innerHTML=body
		window.location.reload()
	}
	if(!data) return <motion.div className="container" exit={{opacity:0}} variants={contVariant} initial="hidden" animate="visible"><h2>Something went wrong, please resave the data</h2></motion.div>
	return (
		<>
		<motion.div className="container" style={{flexDirection:"column"}} exit={{opacity:0}}
			variants={contVariant}
        	initial="hidden"
        	animate="visible"
		>
			<div>
				<button className="save-btn mx-2" onClick={()=>history.push("/choose-resume-template")}>Back</button>
				<button className="save-btn" onClick={download}>Download</button>
			</div>
			<div className="resume" id="resume">
				<div className="mt-1 p-3" style={{textAlign:"left",fontWeight:400,background:"white",color:"black"}}>
					<h1><strong>{data.name}</strong></h1>
					<p className="pb-0 mb-0"><em>{data.designation}</em></p>
				</div>
				<hr color="lightgrey" className="m-0"/>
				<div className="section2 ">
					<div className="mt-5 ml-0">
					<div className="head"><i className="fa fa-info my-3" aria-hidden="true"></i>  Info</div>
					<p><strong><i className="fas fa-address-card ml-2 mr-2"></i></strong><span style={{marginLeft:"4%"}}>{data.address}</span></p>
					<p><strong><i className="fas fa-phone ml-2 mr-2"></i></strong><span style={{marginLeft:"5%"}}>{data.contact}</span></p>
					<p><strong><i className="fas fa-envelope-open ml-2 mr-2"></i></strong><span style={{marginLeft:"5%"}}><a href={`mailto:${data.email}`} style={{color:"black"}}>{data.email}</a></span></p>
					</div>
					<ul className="temp-3 mt-5 ml-0 pl-0" style={{listStyle:"none"}}>
					<li><div className="head"><i className="fas fa-code"></i>  Skills</div>
						<div className="my-2">
							<ul className="skills" style={{listStyle:"none"}}>
							{data.skills.map((skill,index)=>(
								<li className="pl-2">{skill.skill}
									{skill.prof && (<div className="progress" style={{width:"100%"}}>
  									<div className="progress-bar progress-bar-striped progress-bar-animated " role="progressbar" aria-valuenow={skill.prof} aria-valuemin="0" aria-valuemax="100" style={{width:`${skill.prof}%`}}></div>
									</div>
									)}
								</li>
							))}
							</ul>
						</div>
					</li>
					<li><div className="head"><i className="fas fa-clipboard-list "></i>  Additional Info</div>
						<div className="my-3">
							<ul>
							{data.addInfo.map((info,index)=>(
								<li className="pl-2"><strong>{info.title}</strong>  : <a href={`${info.reference}`}><small>{info.reference}</small></a></li>
							))}
							</ul>
						</div>
					</li>
					<li><div className="head"><i className="fas fa-laptop-code "></i>  Projects</div>
						<div className="my-3">
							<ul>
							{data.projects.map((project,index)=>(
								<li className="pl-2"><strong>{project.title}</strong><br/>
									<small>{project.desc}</small><br/>
									<small><a href={`${project.reference}`}>{project.reference}</a></small>
								</li>
							))}
							</ul>
						</div>
					</li>
					</ul>
				</div>
				<div className="section1">
					<ul className="mt-5 ml-0 pl-0" style={{listStyle:"none"}}>
					<li><div className="head"><i className="fas fa-graduation-cap"></i>  Education</div>
						<div className="my-2">
							<ul>
							{data.education.map((edu,index)=>(
								<li className="pl-2">
									<p><strong className="education">{edu.course}</strong><br/>
									   {edu.field}<br/>
									   {edu.college}<br/>
									   Aggregate : {edu.score}%<br/>
									   <em>({(new Date(edu.start)).toDateString().substring(4,8)+(new Date(edu.start)).toDateString().substring(11)} - {(new Date(edu.end)).toDateString().substring(4,8)+(new Date(edu.end)).toDateString().substring(11)})</em>
									</p>
								</li>
							))}
							</ul>
						</div>
					</li>
					<li ><div className="head"><i className="fa fa-briefcase" aria-hidden="true"></i>  Work Experience</div>
						<div className="my-3">
							<ul>
							{data.workExp.map((work,index)=>(
								<li className="pl-2"><strong>{work.company}</strong><br/>
									<p>{work.desc}<br/>
									- <em>{work.title}</em>
									</p>
								</li>
							))}
							</ul>
						</div>
					</li>
					<li><div className="head"><i className="fas fa-book-reader"></i>  Interests</div>
						<div  className="my-3">
							<ul>
							{data.interests.map((interest,index)=>(
								<li className="pl-2">{interest}</li>
							))}
							</ul>
						</div>
					</li>
					<li><div className="head"><i className="fa fa-language" aria-hidden="true"></i>   Languages Known</div>
						<div  className="my-3 lang">
							<ul className="lang" style={{listStyle:"none"}}>
							{data.langKnown.map((lang,index)=>(
								<><li className="pl-2">{lang}</li><hr className="pl-2"/></>
							))}
							</ul>
						</div>
					</li>
					</ul>
				</div>
			</div>
		</motion.div>
		</>
	)
}